var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconCloseComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-close ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05723 8.00016L3.43101 4.37394C3.30083 4.24376 3.30083 4.03271 3.43101 3.90253L3.90241 3.43113C4.03258 3.30095 4.24364 3.30095 4.37381 3.43113L8.00004 7.05735L11.6263 3.43113C11.7564 3.30095 11.9675 3.30095 12.0977 3.43113L12.5691 3.90253C12.6993 4.03271 12.6993 4.24376 12.5691 4.37394L8.94285 8.00016L12.5691 11.6264C12.6993 11.7566 12.6993 11.9676 12.5691 12.0978L12.0977 12.5692C11.9675 12.6994 11.7564 12.6994 11.6263 12.5692L8.00004 8.94297L4.37381 12.5692C4.24364 12.6994 4.03258 12.6994 3.90241 12.5692L3.43101 12.0978C3.30083 11.9676 3.30083 11.7566 3.43101 11.6264L7.05723 8.00016Z",
    fillOpacity: "1"
  }));
}
var IconClose = /*#__PURE__*/React.forwardRef(IconCloseComponent);
export default IconClose;